import React from 'react';
import { Stack, CircularProgress } from '@mui/material';

export const ListLoading = () => (
  <Stack height="100%" width="100%" alignItems="center" justifyContent="center">
    <CircularProgress className="progressLoader" size={48} />
  </Stack>
);
